import WarpElement from "@warp-ds/elements-core";
import { css, html, nothing } from "lit";
import { SearchFilter } from "../../../models/filters.js";
import { Subvertical } from "../../../constants.js";
import { i18n } from "@lingui/core";
import { activateI18n } from "../../../utils/i18n.js";

const minMakeWithModelCount = 5;
const maxMakeWithModelCount = 10;
const minMakeWithoutModelCount = 20;
const maxMakeWithoutModelCount = 40;

class MakeModelSeoLinks extends WarpElement {
    declare makeModelLinks: SearchFilter[];
    declare subvertical: Subvertical;
    declare showMoreMakes: boolean;

    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-r1YmjU;
        `,
    ];

    static properties = {
        makeModelLinks: { type: Array },
        subvertical: { type: String },
        showMoreMakes: { type: Boolean },
    };

    constructor() {
        super();
        this.showMoreMakes = false;
    }

    connectedCallback() {
        activateI18n();
        super.connectedCallback();
    }

    showMakeWithModels = () => this.makeModelLinks.length > 0 && this.makeModelLinks[0].links && this.makeModelLinks[0].links.length > 0;

    defaultMakesToShow = () => (this.showMakeWithModels() ? minMakeWithModelCount : minMakeWithoutModelCount);

    makesToShow = () => {
        if (this.showMakeWithModels()) {
            return this.showMoreMakes ? maxMakeWithModelCount : minMakeWithModelCount;
        }
        return this.showMoreMakes ? maxMakeWithoutModelCount : minMakeWithoutModelCount;
    };

    getPageTitle(subvertical: Subvertical): string | undefined {
        switch (subvertical) {
            case Subvertical.Car:
                return i18n.t({
                    id: "make-model-links.title.car",
                    message: "Common car brands",
                });
            case Subvertical.Boat:
                return i18n.t({
                    id: "make-model-links.title.boat",
                    message: "Common boat brands",
                });
            case Subvertical.Mc:
                return i18n.t({
                    id: "make-model-links.title.mc",
                    message: "Common motorcycle brands",
                });
            case Subvertical.B2B:
                return i18n.t({
                    id: "make-model-links.title.b2b",
                    message: "Common b2b brands",
                });
        }
    }

    toggleShowMoreMakes() {
        this.showMoreMakes = !this.showMoreMakes;
    }

    render() {
        return html`
            <div class="flex relative -mx-[31px]">
                <hr class="absolute left-1/2 -translate-x-1/2 w-screen -z-10" />
                <div class="max-w-[1024] flex flex-col gap-16 w-full px-[31px] relative">
                    <hr class="absolute left-0 right-0 -z-5" />
                    <h3 class="t3 pt-56 relative z-10">${this.getPageTitle(this.subvertical)}</h3>
                        ${
                            this.showMakeWithModels()
                                ? html`<mfp-make-with-model-links
                                      makeModelLinks="${JSON.stringify(this.makeModelLinks)}"
                                      subvertical="${JSON.stringify(this.subvertical)}"
                                      makesToShow="${JSON.stringify(this.makesToShow())}"
                                  ></mfp-make-with-model-links>`
                                : html`<mfp-make-links
                                      makeModelLinks="${JSON.stringify(this.makeModelLinks)}"
                                      subvertical="${JSON.stringify(this.subvertical)}"
                                      makesToShow="${JSON.stringify(this.makesToShow())}"
                                  ></mfp-make-links>`
                        }
                    ${
                        this.makeModelLinks.length > this.defaultMakesToShow()
                            ? html`<div>
                                  <button @click="${this.toggleShowMoreMakes}" class="s-text-link bg-transparent hover:underline">
                                      ${this.showMoreMakes
                                          ? i18n.t({ id: "make-model-links.expand-makes-rows.show-less", message: "Show less makes" })
                                          : i18n.t({ id: "make-model-links.expand-makes-rows.show-more", message: "Show more makes" })}
                                  </button>
                              </div>`
                            : nothing
                    }
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define("mfp-make-model-seo-links", MakeModelSeoLinks as unknown as CustomElementConstructor);
